import fromEvent from 'xstream/extra/fromEvent'
import xs from 'xstream'

export default function jqueryDriver () {
  return (instruction$) => {
    instruction$.addListener({
      next: fn => {
        if (typeof fn === 'function') {fn()}
        else {fn.call()}
      },
      error: err => {throw err},
      complete: () => {},
    })

    const attachListeners$ = instruction$
      .filter(({reAttachListeners}) => !!reAttachListeners)
      .startWith('')

    return api({path: '', selector: '', root: document})

    function api ({path = '', selector = '', root = document}) {
      function getElements (selector_) {
        if(!selector_) return [root]
        return [...root.querySelectorAll(selector_)]
      }

      return {
        scope: (selector_, fn) => {
          const sel = (selector + ' ' + selector_).trim()
          const path_ = (path + ' ' + sel).trim()

          return xs.merge(
            ...getElements(sel).map(x => fn(api({selector: '', root: x, path: path_})))
          )
        },
        select: (selector_) => {
          const sel = (selector + ' ' + selector_).trim()
          const path_ = (path + ' ' + sel).trim()
          return api({selector: sel, root, path: path_})
        },
        events: (event) => {
          return attachListeners$
            .map(() => getElements(selector))
            .map(els => els.map(el => fromEvent(el, event)))
            .map(ev$s => xs.merge(...ev$s))
            .flatten()
        },
        elements: () => attachListeners$.map(() => getElements(selector)),
        element: () => attachListeners$.map(() => getElements(selector)[0]),
        window: () => ({
          element: () => xs.of(window),
          elements: () => xs.of([window]),
          events: (event) => fromEvent(window, event),
        }),
      }
    }
  }
}



// WEBPACK FOOTER //
// ./drivers/DOMmutationDriver.js